import { beginMessage } from '../message';
import { MessageTag } from '../messageTags';
import { Role } from '../enums';
import type { BinaryReader } from '../BinaryReader';

/**
 * In-game quick-chat codec. Mirrors Unity's `TableInformation.SendChatMessage` (C2S) and the
 * server's `GameBase.HandleChat` (S2C). The protocol is a plain string both ways — the client
 * sends one of the predefined phrases verbatim; the server echoes it back to the opponent (and
 * watchers) tagged with the sender's role. No server change is needed.
 */

/**
 * The predefined quick-chat phrases, in the Unity Blackjack.unity button order (the `SendChatMessage`
 * bindings). These are exactly what existing players see, so familiarity is preserved.
 */
export const CHAT_PHRASES: readonly string[] = [
  'خخخخخخ',
  'شرمنده',
  'ممنون',
  'عمرا بتوني!!',
  'عجله کن',
  'موفق باشي',
  'لعنتي',
  'Ooopss',
  'نوبت توست',
];

/** C2S Chat(50): a single string (the chosen phrase). */
export function encodeChat(text: string): Uint8Array {
  return beginMessage(MessageTag.Chat).putString(text).toUint8Array();
}

export interface ChatPayload {
  text: string;
  /** Which seat sent it — used to pop the bubble over the right avatar. */
  senderRole: Role;
}

/** S2C Chat(50): string text + short senderRole. */
export function decodeChat(r: BinaryReader): ChatPayload {
  return {
    text: r.getString(),
    senderRole: r.getShort() as Role,
  };
}
